import { useQuery } from '@tanstack/react-query';
import { PatientDocument } from 'src/models';
import { ambientApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type UseGetEncounterDocumentListParams = {
  encounterId: string;
  includePresignedUrl?: boolean;
};

export type GetEncounterDocumentListResponse = {
  encounter_documents: PatientDocument[];
};

export const useGetEncounterDocumentList = (
  params: UseGetEncounterDocumentListParams,
  options?: UseQueryOverrideOptions
) => {
  const { encounterId, includePresignedUrl } = params;
  return useQuery({
    ...options,
    queryKey: ['encounterDocumentList', params],
    queryFn: () =>
      ambientApi
        .get<GetEncounterDocumentListResponse>(
          `/encounters/${encounterId}/documents`,
          {
            params: {
              include_presigned_url: includePresignedUrl,
            },
          }
        )
        .then(({ data }) => ({
          encounterDocuments: data.encounter_documents || [],
        })),
  });
};
